import * as actionTypes from '../actions/actionTypes';
import * as cTypes from 'config/ConfigTypes';

const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null


const INITIAL_STATE = {
    loading: true,
    authObjects: {
        authForm: "login",
        showAuth: false,
        isLoggedIn: user ? true : false,
        loginErr: false,
        [cTypes.INST_DATA]: {},
        user: user,
    }
}

const AuthReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.AUTH_UPDATE_AUTHOBJECTS:
            return {
                loading: true
            }
        case actionTypes.AUTH_UPDATE_AUTHOBJECTS_SUCCESS:
            return {
                loading: false,
                authObjects: { ...state.authObjects, ...action.payload }
            }
        case actionTypes.AUTH_SET_INITIAL_STATE:
            let initObj = { ...INITIAL_STATE.authObjects, user: state.authObjects.user, ...action.payload }
            return {
                loading: false,
                authObjects: initObj
            }
        default:
            return state;
    }
}

export default AuthReducer;